import React from 'react';

import { Stack } from '@reckon-web/stack';
import { css } from '@reckon-web/core';
import { useTheme } from '@reckon-web/theme';

const BAR_GAP = 6;

export type PasswordStrengthProps = {
  score?: 1 | 2 | 3 | 4 | 5;
};

export const PasswordStrength: React.FC<PasswordStrengthProps> = ({
  score,
}) => {
  const { palette } = useTheme();
  const defaultColor = palette.text['dim'];
  const scores = {
    1: palette.text['critical'],
    2: palette.text['critical'],
    3: palette.text['critical'],
    4: palette.text['critical'],
    5: palette.text['positive'],
  };

  const beforeAfterStyles = {
    boxSizing: 'border-box',
    position: 'absolute',
    content: '""',
    height: 'inherit',
    background: 'transparent',
    display: 'block',
    borderColor: palette.background.base,
    borderStyle: 'solid',
    borderWidth: `0 ${BAR_GAP}px 0`,
    width: `calc(20% + ${BAR_GAP}px)`,
    zIndex: 10,
  } as const;

  const barStyles = css`
    background: transparent;
    height: inherit;
    position: absolute;
    width: 0;
    border-radius: inherit;
    transition:
      width 0.5s ease-in-out,
      background 0.25s;
    &[data-strength='${score}'] {
      background: ${score ? scores[score] : defaultColor};
      width: calc(20% * ${score});
    }
  `;

  return (
    <Stack>
      <div
        css={{
          position: 'relative',
          height: 3,
          background: defaultColor,
          borderRadius: 2,
          '::before': {
            left: 'calc(20% - 3px)',
            ...beforeAfterStyles,
          },
          '::after': {
            right: 'calc(20% - 3px)',
            ...beforeAfterStyles,
          },
        }}
      >
        <div data-strength={score} css={barStyles} />
      </div>
    </Stack>
  );
};
